import {
  Box,
  Typography,
  Button,
  TextField,
  Alert,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import {
  LocalizationProvider,
  DatePicker,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import "dayjs/locale/es";
import dayjs from "dayjs";

import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import GridOnIcon from "@mui/icons-material/GridOn";

import { useEffect, useCallback, useState } from "react";

import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

import Header from "../../components/Header";
import { getUniformesAsignacion } from "../../services/uniformes.services";
import { getApiImagen } from "../../utils/getApiBaseUrl";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
const buildColumnsStockMin = ({ rows }) => {
  return [
    {
      field: "id_producto",
      headerName: "ID",
      width: 70,

      renderCell: (params) => (
        <Typography sx={{ fontSize: "12px", color: "text.secondary" }}>
          #{params.value}
        </Typography>
      ),
    },

    {
      field: "descripcion",
      headerName: "Descripción",
      flex: 0.7,

      renderCell: (params) => (
        <Typography sx={{ fontSize: "13px", fontWeight: 500 }}>
          {params.value}
        </Typography>
      ),
    },

    {
      field: "talla",
      headerName: "Talla",
      width: 90,
    },

    {
      field: "total_asignaciones",
      headerName: "Cantidad usada",
      width: 160,

      renderCell: (params) => (
        <Box
          sx={{
            display: "inline-flex",
            alignItems: "center",
            gap: 0.75,
            background: "rgba(62,67,150,0.08)",
            border: "1px solid rgba(62,67,150,0.18)",
            borderRadius: "20px",
            px: 1.5,
            py: 0.3,
          }}
        >
          <Box
            sx={{
              width: 6,
              height: 6,
              borderRadius: "50%",
              background: "#ffa726",
            }}
          />

          <Typography
            sx={{
              fontSize: "18px",
              fontWeight: 700,
              color: "#ffa726",
            }}
          >
            {params.value}
          </Typography>
        </Box>
      ),
    },

    {
      field: "img",
      headerName: "Imagen",
      flex: 0.6,

      renderCell: (params) => (
        <img
          src={`${getApiImagen()}${params.value}`}
          alt="Uniforme"
          style={{
            width: "150px",
            height: "100px",
            objectFit: "cover",
            borderRadius: "10px",
          }}
        />
      ),
    },
  ];
};


const TopUniformes = () => {
  const hoy = dayjs();

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  const [fechaInicio, setFechaInicio] = useState(hoy);
  const [fechaFin, setFechaFin] = useState(hoy);

  const [errorFecha, setErrorFecha] = useState("");

  const fetchData = useCallback(async () => {
    if (fechaInicio.isAfter(fechaFin)) {
      setErrorFecha(
        "La fecha inicio no puede ser mayor a la fecha fin",
      );

      setRows([]);
      return;
    }

    setErrorFecha("");

    try {
      setLoading(true);

      const data = await getUniformesAsignacion({
        fecha_inicio: fechaInicio.format("YYYY-MM-DD"),
        fecha_fin: fechaFin.format("YYYY-MM-DD"),
      });

      setRows(data || []);
    } catch (err) {
      console.error(err);
      setRows([]);
    } finally {
      setLoading(false);
    }
  }, [fechaInicio, fechaFin]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const columns = buildColumnsStockMin({ rows });
      const exportarExcel = async () => {
  const workbook = new ExcelJS.Workbook();

  // 🔹 HOJA PRINCIPAL
  const sheet = workbook.addWorksheet("Stock Minimos");

  sheet.columns = [
    { header: "ID", key: "id_producto", width: 10 },
    { header: "Descripción", key: "descripcion", width: 30 },
    { header: "Talla", key: "talla", width: 12 },
    { header: "Cantidad usada", key: "total_asignaciones", width: 20 },
  ];

  rows.forEach((r) => {
    sheet.addRow({
      id_producto: r.id_producto,
      descripcion: r.descripcion,
      talla: r.talla,
      total_asignaciones: r.total_asignaciones,
    });
  });

  // 🔹 ESTILO CABECERA
  sheet.getRow(1).eachCell((cell) => {
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FF3E4396" },
    };

    cell.font = {
      color: { argb: "FFFFFFFF" },
      bold: true,
    };

    cell.alignment = {
      vertical: "middle",
      horizontal: "left",
    };
  });

  // 🔹 BORDES Y AJUSTES
  sheet.eachRow((row) => {
    row.eachCell((cell) => {
      cell.border = {
        top: { style: "thin", color: { argb: "FFE0E0E0" } },
        left: { style: "thin", color: { argb: "FFE0E0E0" } },
        bottom: { style: "thin", color: { argb: "FFE0E0E0" } },
        right: { style: "thin", color: { argb: "FFE0E0E0" } },
      };
    });
  });

  // 💾 DESCARGA
  const buffer = await workbook.xlsx.writeBuffer();

  const fileData = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  saveAs(fileData, "Tops_Uniformes.xlsx");
};
 const exportarPDF = () => {
  const doc = new jsPDF("landscape");

  // 🔹 TÍTULO
  doc.setFontSize(18);

  doc.text("Reporte de Uniformes más usados", 14, 15);

  doc.setFontSize(11);

  doc.text(
    `Rango: ${fechaInicio.format("DD/MM/YYYY")} - ${fechaFin.format(
      "DD/MM/YYYY",
    )}`,
    14,
    24,
  );

  // 🔹 TABLA
  autoTable(doc, {
    startY: 32,

    head: [
      [
        "ID",
        "Descripcion",
        "Talla",
        "Cantidad usada",
      ],
    ],

    body: rows.map((r) => [
      r.id_producto,
      r.descripcion,
      r.talla,
      r.total_asignaciones,
    ]),

    headStyles: {
      fillColor: [62, 67, 150],
      textColor: [255, 255, 255],
      fontStyle: "bold",
    },

    styles: {
      fontSize: 8,
    },
  });

  doc.save("Tops_Uniformes.pdf");
};
  return (
    <Box m="20px">
      <Header
        title="Top de uniformes"
        subtitle="Uniformes más utilizados"
      />

      {/* FILTROS */}
      <Box
        sx={{
          display: "flex",
          gap: 2,
          mb: 3,
          flexWrap: "wrap",
          alignItems: "center",
        }}
      >
        <LocalizationProvider
          dateAdapter={AdapterDayjs}
          adapterLocale="es"
        >
          <DatePicker
            label="Fecha inicio"
            value={fechaInicio}
            format="DD/MM/YYYY"
            onChange={(value) => {
              if (!value) return;

              setFechaInicio(value);

              // evita automáticamente error visual
              if (value.isAfter(fechaFin)) {
                setFechaFin(value);
              }
            }}
          />

          <DatePicker
            label="Fecha fin"
            value={fechaFin}
            minDate={fechaInicio}
            format="DD/MM/YYYY"
            onChange={(value) => {
              if (!value) return;

              setFechaFin(value);
            }}
          />
        </LocalizationProvider>
              {/* PDF */}
  <Button
    onClick={exportarPDF}
    disabled={!rows.length || !!errorFecha}
    sx={{
      border: "1px solid #e53935",
      color: "#e53935",
      borderRadius: "10px",
      px: 2,
      py: 1,
      textTransform: "none",
      fontWeight: 600,

      "&:hover": {
        background: "rgba(229,57,53,0.08)",
      },
    }}
  >
    <img
      src="https://cdn-icons-png.flaticon.com/512/337/337946.png"
      alt="PDF Icon"
      style={{
        width: 29,
        height: 29,
        marginRight: 8,
      }}
    />

    Exportar PDF
  </Button>

  {/* EXCEL */}
  <Button
    onClick={exportarExcel}
    disabled={!rows.length || !!errorFecha}
    sx={{
      border: "1px solid #2e7d32",
      color: "#2e7d32",
      borderRadius: "10px",
      px: 2,
      py: 1,
      textTransform: "none",
      fontWeight: 600,

      "&:hover": {
        background: "rgba(46,125,50,0.08)",
      },
    }}
  >
    <img
      src="https://cdn-icons-png.flaticon.com/512/732/732220.png"
      alt="Excel Icon"
      style={{
        width: 24,
        height: 24,
        marginRight: 8,
      }}
    />

    Exportar Excel
  </Button>

      </Box>
      <Box
  sx={{
    display: "flex",
    gap: 1,
    mb: 2,
  }}
>
</Box>

      {/* ERROR */}
      {errorFecha && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {errorFecha}
        </Alert>
      )}

      {/* DATAGRID */}
      <Box
        sx={{
          "& .MuiDataGrid-root": {
            border: "0.5px solid rgba(128,128,128,0.2)",
            borderRadius: "16px",
          },

          "& .MuiDataGrid-columnHeaders": {
            background: "rgba(128,128,128,0.04)",
            borderBottom: "0.5px solid rgba(128,128,128,0.15)",
            fontSize: "10px",
            fontWeight: 700,
            letterSpacing: "0.07em",
            textTransform: "uppercase",
          },
        }}
      >
        <DataGrid
          rows={rows}
          columns={columns}
          getRowId={(row) =>
            `${row.id_producto}-${row.fecha_entrega}`
          }
          loading={loading}
          rowHeight={80}
          autoHeight
          disableRowSelectionOnClick
          pageSizeOptions={[10, 25, 50]}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 10,
              },
            },
          }}
          localeText={{
            noRowsLabel: errorFecha
              ? "Rango de fechas inválido"
              : "Sin registros",
          }}
        />
      </Box>
    </Box>
  );
};


export default TopUniformes;
